// import paths from "../../../api/paths";

export const sections = [
  // {
  //   id: "home",
  //   label: "Home",
  //   // link: paths.storyPage,
  // },
  {
    id: "story",
    label: "Story",
    // link: paths.storyPage,
  },
  {
    id: "philosophy",
    label: "Philosophy",
    // link: paths.philosophyPage,
  },
  {
    id: "approach",
    label: "Approach",
    // link: paths.approachPage,
  },
  {
    id: "expertise",
    label: "Expertise",
    // link: paths.expertisePage,
  },
  {
    id: "founder",
    label: "Founder",
    // link: paths.founderPage,
  },
  {
    id: "contact",
    label: "Contact",
    // link: paths.contactPage,
  },
];
